export const placeholderImage = {
  id: 'cG9zdDoxNjI2',
  alt: 'alt',
  caption: 'caption',
  sourceUrl: '/images/placeholder.jpg',
  width: 3200,
  height: 2133,
};

export const placeholderVideo = {
  id: 'cG9zdDo0MDE=',
  caption: '',
  url: '/images/placeholder-2.mp4',
  width: 3840,
  height: 2160,
};

export const placeholderCta = {
  buttonLabel: 'Button Label',
  type: 'link',
  isExternal: false,
  url: '/',
};

export const placeholderFile = {
  date: '2025-01-30T03:40:12',
  fileSize: 2054,
  id: 'cG9zdDozNDI=',
  link: '/images/placeholder.jpg',
  title: 'Placeholder File',
};

export const placeholderCardHero = {
  heading: 'Real World Ready',
  description:
    'Building strong foundations in learning, confidence and connection',
  label: 'label',
  link: {
    target: '_blank',
    title: 'card title',
    url: '/',
  },
  image: placeholderImage,
};

export const placeholderCard = {
  heading: 'Literacy and communication',
  subheading: 'Mar 12, 2026 : 1 min read',
  description:
    'At TQS, we’re proud to offer a range of classes that help students build self-awareness and practice self-care, strengthening their sense of who they are. Combined with academics, students take part in creative experiences such as:',
  label: 'label',
  tag: 'tag',
  link: {
    target: '_blank',
    title: 'card title',
    url: '/',
  },
  cta: placeholderCta,
  image: placeholderImage,
};

// export const DEMO_DATA = [
//   {
//     type: '',
//     heading: 'Heading text - Lorem ipsum dolor sit amet',
//     subheading: 'Subheading text - Lorem ipsum dolor sit amet',
//     description: 'Description text - Lorem ipsum dolor sit amet',
//     image: placeholderImage,
//     content:
//       '<p><strong>Lorem ipsum dolor</strong> sit amet, consectetur adipiscing elit, sed do eiusmod  ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa .</p>\n<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna iquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n<p><a href=\"https://www.google.com\">link test</a></p>\n',
//     cta: placeholderCta,
//     ctaSecondary: placeholderCta,
//     colorTheme: 'light',
//   },
// ];

export const placeholderHtml =
  '<p><strong>Lorem ipsum dolor</strong>  sit amet, consectetur adipiscing elit, sed do eiusmod  ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa .</p>\n<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna iquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>';
// '<p>Lorem ipsum  consequat. Duis aute irure dolor in reprehenderit in voluptate iat nulla pariaturdatat non proident, sunt in culpa .</p>\n<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed  consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>\n<p><a href=\"https://www.google.com\">link test</a></p>\n';
